var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":_vm.fill,"width":_vm.width,"height":_vm.height,"viewBox":`0 0 ${_vm.vbWidth} ${_vm.vbHeight}`,"role":"presentation"}},[_c('g',{attrs:{"stroke":_vm.stroke,"stroke-linecap":"round","stroke-width":_vm.strokeWidth},domProps:{"innerHTML":_vm._s(_vm.icon)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }